import React, { FC } from 'react';

export const Logo: FC<any> = props => {
  const { fullSize = true } = props;

  return (
    <svg
      height="100%"
      strokeMiterlimit="10"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      version="1.1"
      viewBox="0 0 26 26"
      width="100%"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs />
      <g id="Untitled">
        <g opacity="1">
          <g opacity="1">
            <path
              d="M10.8736 4.34726C6.27362 5.64726 3.57362 10.4473 4.87362 14.9473C5.67362 17.8473 7.97362 20.0473 10.6736 20.8473L10.6736 20.8473C8.17362 19.9473 6.17362 17.9473 5.47362 15.2473C4.27362 10.8473 6.77362 6.34726 11.1736 5.14726C15.3736 3.94726 19.7736 6.34726 21.1736 10.3473C21.2736 10.3473 21.4736 10.3473 21.5736 10.2473L21.5736 10.2473C20.2736 5.74727 15.4736 3.04726 10.8736 4.34726Z"
              fill="#35174d"
              opacity="1"
              stroke="none"
            />
            <path
              d="M2.07363 15.8473C0.373631 9.74726 3.97363 3.34726 10.0736 1.54726C16.1736-0.152741 22.5736 3.44726 24.3736 9.54726C24.4736 9.84726 24.4736 10.0473 24.5736 10.3473C24.7736 10.3473 24.9736 10.3473 25.0736 10.4473C24.9736 9.94726 24.8736 9.34726 24.7736 8.84726C22.9736 2.44726 16.2736-1.35274 9.77363 0.44726C3.37363 2.24726-0.426368 8.94726 1.37363 15.4473C2.67363 20.0473 6.47363 23.3473 10.9736 24.1473L10.9736 24.1473C6.77363 23.1473 3.27363 20.1473 2.07363 15.8473Z"
              fill="#35174d"
              opacity="1"
              stroke="none"
            />
            <path
              d="M10.6736 20.9473C11.1736 21.1473 11.6736 21.2473 12.2736 21.2473C11.6736 21.2473 11.1736 21.0473 10.6736 20.9473L10.6736 20.9473Z"
              fill="#35174d"
              opacity="1"
              stroke="none"
            />
            <path
              d="M10.8736 24.0473L10.8736 24.0473C11.1736 24.1473 11.3736 24.1473 11.6736 24.1473C11.3736 24.1473 11.1736 24.0473 10.8736 24.0473Z"
              fill="#35174d"
              opacity="1"
              stroke="none"
            />
          </g>
          <g opacity="1">
            <path
              d="M13.3736 16.6473C13.3736 16.6473 11.5736 16.8473 10.3736 15.5473C9.87362 14.9473 9.57362 13.4473 10.9736 11.4473C10.7736 12.1473 10.9736 12.4473 11.0736 12.4473C11.6736 10.4473 13.5736 8.54726 14.9736 7.34726C14.9736 7.34726 14.0736 9.64726 15.9736 10.4473C15.7736 9.24726 16.1736 8.64726 16.6736 8.44726C16.5736 8.64726 16.4736 9.04726 16.6736 9.24726C16.9736 9.54726 17.8736 10.2473 17.9736 11.7473C18.0736 12.7473 17.7736 13.4473 17.1736 14.1473C16.5736 15.0473 15.2736 15.8473 15.2736 15.8473C15.2736 15.8473 16.4736 14.4473 16.2736 13.3473C16.1736 12.6473 15.4736 12.7473 15.0736 11.9473C14.6736 12.3473 14.6736 12.8473 14.7736 13.3473C13.4736 13.3473 13.1736 11.8473 13.3736 10.9473C11.9736 11.9473 11.5736 13.5473 11.8736 14.7473C11.5736 14.7473 11.4736 14.6473 11.3736 14.5473C11.9736 15.9473 12.8736 16.3473 13.3736 16.6473Z"
              fill="#35174d"
              opacity="1"
              stroke="none"
            />
            <g opacity="1">
              <path
                d="M17.6736 19.3473L15.2736 20.3473L13.4736 18.5473C13.2736 18.3473 13.3736 18.0473 13.5736 17.9473L16.9736 16.5473C17.1736 16.4473 17.4736 16.6473 17.4736 16.8473L17.6736 19.3473Z"
                fill="#35174d"
                opacity="1"
                stroke="none"
              />
              <path
                d="M19.5736 25.4473C19.5736 25.4473 19.5736 25.9473 19.1736 26.1473C18.7736 26.3473 18.3736 25.9473 18.3736 25.9473L15.6736 21.3473L17.9736 20.3473L19.5736 25.4473Z"
                fill="#35174d"
                opacity="1"
                stroke="none"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
